import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/consumer/Placeholder';
import CtaButton from 'components/essentials/Cta/CtaButton';
import PDPDetailsAndProductCareLink from '../PDPDetailsAndProductCareLink';
const PDPProductDescriptionUI = t0 => {
  const $ = _c(9);
  const {
    loading,
    buttonText,
    description,
    headline,
    onButtonClick
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Placeholder loading={true} type="rect" className="text-xl font-bold text-gray mb-4 PDPProductDescriptionUI__headline--loading" style={{
        height: "64px"
      }} />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Placeholder loading={true} type="rect" className="text-sm text-gray m-0 PDPProductDescriptionUI__description--loading" style={{
        height: "121px"
      }} />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Placeholder loading={true} type="rect" style={{
        height: "39px",
        width: "235px",
        marginTop: "20px"
      }} />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="border-t border-solid border-gray-light6 mt-14 pt-14">{t1}{t2}{t3}<Placeholder type="rect" loading={true} style={{
          height: "26px",
          width: "174px",
          marginTop: "1.5rem"
        }} /></div>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t1;
  if ($[4] !== buttonText || $[5] !== description || $[6] !== headline || $[7] !== onButtonClick) {
    t1 = headline || description ? <div className="border-t border-solid border-gray-light6 mt-14 pt-14">{headline && description ? <><h2 className="text-xl font-bold text-gray mb-4">{headline}</h2><p className="text-sm text-gray m-0">{description}</p></> : <h2 className="text-sm text-gray m-0">{headline || description}</h2>}<div className="mt-6"><PDPDetailsAndProductCareLink /></div>{!!buttonText && !!onButtonClick && <CtaButton styling="solid-button" color="brand" size="sm" spacing="sm" onClick={onButtonClick} className="mt-4">{buttonText}</CtaButton>}</div> : <div className="PDPProductDescriptionUI__filler" />;
    $[4] = buttonText;
    $[5] = description;
    $[6] = headline;
    $[7] = onButtonClick;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};
PDPProductDescriptionUI.propTypes = {
  buttonText: PropTypes.string,
  description: PropTypes.string,
  headline: PropTypes.string,
  onButtonClick: PropTypes.func,
  loading: PropTypes.bool
};
export default PDPProductDescriptionUI;